(function () {
  'use strict';

  function setup(scope) {
    scope.querySelectorAll('[data-jp-article-share]').forEach(function (group) {
      var nativeButton = group.querySelector('[data-jp-article-share-native]');
      if (nativeButton) nativeButton.hidden = typeof navigator.share !== 'function';
    });
  }

  function copyUsingSelection(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
    document.body.appendChild(input);
    input.select();
    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    input.remove();
    return copied;
  }

  function setStatus(group, message) {
    var status = group.querySelector('[data-jp-article-share-status]');
    if (status) status.textContent = message;
  }

  async function copyLink(group, url) {
    var button = group.querySelector('[data-jp-article-share-copy]');
    var label = group.querySelector('[data-jp-article-share-copy-label]');
    var copied = false;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        copied = true;
      } catch (error) {
        // Clipboard access can be blocked even on HTTPS; try a local selection.
      }
    }
    if (!copied) copied = copyUsingSelection(url);
    if (!copied) {
      setStatus(group, 'Select and copy the link in the dialog.');
      window.prompt('Copy this article link', url);
      return;
    }
    label.textContent = 'Copied!';
    setStatus(group, 'Article link copied.');
    window.clearTimeout(button._jpResetTimer);
    button._jpResetTimer = window.setTimeout(function () {
      label.textContent = 'Copy link';
    }, 2500);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-jp-article-share-native], [data-jp-article-share-copy]');
    if (!button) return;
    var group = button.closest('[data-jp-article-share]');
    if (!group) return;
    var url = new URL(group.dataset.jpArticleUrl, window.location.origin).href;
    if (button.hasAttribute('data-jp-article-share-copy')) {
      copyLink(group, url);
      return;
    }
    if (typeof navigator.share !== 'function') {
      copyLink(group, url);
      return;
    }
    navigator.share({ title: group.dataset.jpArticleTitle, url: url }).catch(function (error) {
      if (!error || error.name !== 'AbortError') {
        setStatus(group, 'Sharing is unavailable. Use Copy link instead.');
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
}());